import React from "react";
import { View, StyleSheet, TouchableOpacity } from "react-native";
import {
  VideoPrevious,
  VideoBackword,
  VideoForward,
  VideoPlay,
  VideoPause,
  VideoNext,
  PlayAgain,
} from "./Icons";

const PlayerControls = ({
  isPlaying = true,
  handlePlayPause = () => {},
  skipForward = () => {},
  skipBackword = () => {},
  showPreviousAndNext = false,
  isCompleted = false,
  playAgain = () => {},
  disablePunchSeek = false,
  showFullScreen = false,
}) => {
  return (
    <View
      style={[
        styles.wrapper,
        {
          position: "relative",
          top: showFullScreen ? 50 : 0,
        },
      ]}
    >
      {showPreviousAndNext && (
        <TouchableOpacity style={[styles.touchable]}>
          <VideoPrevious />
        </TouchableOpacity>
      )}

      {!disablePunchSeek && (
        <TouchableOpacity style={[styles.touchable]} onPress={skipBackword}>
          <VideoBackword />
        </TouchableOpacity>
      )}

      <TouchableOpacity
        style={[
          {
            height: 50,
            width: 50,
            borderRadius: 50 / 2,
            backgroundColor: "#fff",
            justifyContent: "center",
            alignItems: "center",
            paddingLeft: !isPlaying ? 5 : 0,
          },
        ]}
        onPress={() => (isCompleted ? playAgain(1) : handlePlayPause())}
      >
        {isCompleted ? (
          <PlayAgain />
        ) : isPlaying ? (
          <VideoPause />
        ) : (
          <VideoPlay />
        )}
      </TouchableOpacity>

      {!disablePunchSeek && (
        <TouchableOpacity style={[styles.touchable]} onPress={skipForward}>
          <VideoForward />
        </TouchableOpacity>
      )}
      {showPreviousAndNext && (
        <TouchableOpacity style={[styles.touchable]}>
          <VideoNext />
        </TouchableOpacity>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    paddingHorizontal: 5,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-evenly",
    flex: 3,
  },
  touchable: {
    padding: 5,
  },
  touchableDisable: {
    opacity: 0.3,
  },
});

export default PlayerControls;
